<template lang="pug">
  .component.component-backoffice-client.client.card(v-if="item")
    .inner-content(v-if="$is('listing')")
      cardN(:columns="7", :showBullets="true", :showAction="true")
        .field-client-dropdown-buttons(slot="actionBullets")
          dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
            client-action-buttons(:client="item")
        .field.field-client-status(slot="n1")
          status(:status="item.status", class="float-left")
          | {{item.id}}
          .field-value(v-if="item.federation !== null") Federation: {{item.federation.name}}

        .field.field-name-surname(slot="n2")
          .name-surname {{item.name}} {{item.surname}}
          .organization-name {{item.organization_name}}
        .field.field-billing-address(slot="n3")
          .field-value {{item.billing_address.city}}
        .field.field-phone(slot="n4")
          .field-value(v-if="item.main_driver")
            .phone {{item.main_driver.phone}}
            .mobile {{item.main_driver.mobile}}
        .field.field-total-drivers(slot="n5", shrink)
          .field-value {{item.drivers.length}}
        .field.field-wallet-balance(slot="n6")
          div Unpaid: {{$priceWithcurrency(item.unpaid_balance)}}
          div Not invoiced: {{$priceWithcurrency(item.wallet.balance)}}
        .field.field-active-since(slot="n7") {{$dateFormat(item.created,  $toMomentFormat(configuration.locale.locale_date_format.value))}}

          //pre {{item.wallet}}

        .field.field-url-detail(slot="actionPage")
          router-link(:to="{name:'client', params:{id:item.id}}")
            i.fa.fa-angle-right.fa-3x.action
    .client-card.card(v-if="$is('client-card')")
      .row.inner-content
        .columns.shrink {{item.picture}}
        .columns
          router-link(:to="{name:'client', params:{id:item.id}}")
            h4 {{item.name}} {{item.surname}} (CL{{item.id}})
          | {{item.client_organization_name}}
      .row
        .columns.text-right
          a(v-if="item.main_driver.mobile", :href="'tel:'+item.main_driver.mobile").fa.fa-phone.fa-lg
          a(v-if="item.email", :href="'mailto:'+item.email").fa.fa-envelope.fa-lg

    .client-approval-card(v-if="$is('client-approval-card')")
      .columns
        .row.inner-content.align-middle
          .columns.shrink
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'left'")
              client-action-buttons(:client="item")
          .columns.small-3.large-1
            router-link(:to="{name:'driver', params:{id:item.main_driver.id}}")
              thumbnail(:image="item.main_driver.profile_picture")
          .columns.small-3.large-2
            p.mb-0 {{item.name}} {{item.surname}}
            p.mb-0 {{item.id}}
            p(v-if="item.federation !== null") Federation: {{item.federation.name}}
          .columns.text-center.align-middle
            AccountStatus(:accountStatus="accountStatus")
          .columns.shrink.text-center.align-middle
            i.fa.fa-clock-o.fa-2x(:class="{activeIcon: true}")
            p.no-wrap {{daysWaiting(item.updated)}}
          .columns.shrink.text-right.align-middle
            h5.mb-0.no-wrap created: {{formatDate(item.created)}}
            h5.mb-0.no-wrap updated: {{formatDate(item.updated)}}
          .columns.shrink
            router-link(:to="{name:'client', params:{id:item.id}}")
              i.fa.fa-angle-right.fa-3x.action
    .inner-content(v-if="$is('personal-data')")
      h3 Personal Data
      hr
      cardN(:columns="3")
        .field.field-first-name(slot="n1")
          .label First Name
          .field-value {{item.name}}
        .field.field-last-name(slot="n2")
          .label Last name
          .field-value {{item.surname}}
        .field.field-client-type(slot="n3")
          .label Client Type
          .field-value {{item.client_type.type}}
      cardN(:columns="3")
        .field.field-member-since(slot="n1")
          .label Member Since
          .field-value {{$dateFormat(item.created,  $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
      cardN(:columns="3" v-if="item.federation !== null")
        .field.field-federation(slot="n1")
          .label Federation
          .field-value {{item.federation.name}}
    .inner-content(v-if="$is('contacts')")
      h3 Contacts
      hr
      simple-columns2
        .field.field-email-address(slot="n1")
          .label Mail Address
          .field-value {{item.email}}
        .field.field-address(slot="n2")
          .label Address
          .address {{item.address.street}} {{item.address.city}} {{item.address.country}}
          .postal-code {{item.address.postal_code}}
        .field.field-phone(slot="n2")
          .label Phone
          .field-value {{item.phone}}
    .inner-content(v-if="$is('billing')")
      h3 Billing Details
      hr
      cardN(:columns="3")
        .field.field-organization-name(slot="n1")
          .label Organization Name
          .field-value {{item.organization_name}}
        .field.field-fiscal-code(slot="n2")
          .label Fiscal Code
          .field-value {{fiscalCode}}
      cardN(:columns="3")
        .field.field-vat-number(slot="n1")
          .label Vat number
          .field-value {{item.vat_number}}
        .field.field-billing-address(slot="n2")
          .label Billing Address
          .address {{item.billing_address.street}} {{item.billing_address.city}} {{item.billing_address.country}}
          .postal-code {{item.billing_address.postal_code}}
      cardN(:columns="1")
        .field.field-extra(slot="n1")
          .values(v-for="(value, label) in extra")
            .label {{label}}
            .value {{value}}
    .inner-content(v-if="$is('main-driver')")
      h3 Main driver
      driver(:type="'driver-card'", :item="item.main_driver")
    .client-status(v-if="$is('client-status')")
      p Status
        br
        | {{item.status}}
    .card(v-if="$is('client-card2')")
      .driver-card.inner-content
        .row.collapse.align-middle
          .columns.small-offset-1
            .client
              router-link(:to="{name:'client', params:{id:item.id}}" )
                span {{item.name}} {{item.surname}} (CL{{item.id}})
        .row.collapse
          .columns.text-right
            a(v-if="item.main_driver.mobile", :href="'tel:'+item.main_driver.mobile").fa.fa-phone.fa-lg
          .columns.text-right.small-1
            a(v-if="item.email", :href="'mailto:'+item.email").fa.fa-envelope.fa-lg
    .inner-content.federation-list(v-if="$is('federationList')")
      cardN(:columns="4")
        .field.field-first-name(slot="n1")
          .label First Name
          .field-value {{item.name}}
        .field.field-last-name(slot="n2")
          .label Last name
          .field-value {{item.surname}}
        .field.field-client-type(slot="n3")
          .label Client Type
          .field-value {{item.client_type.type}}
        .field.field-url-detail.text-right(slot="n4")
          router-link(:to="{name:'client', params:{id:item.id}}")
            i.fa.fa-angle-right.fa-3x.action
    .card(v-if="(item.status ==='SUSPENDED' || item.status ==='ON HOLD') && type === 'highlightedNotes'")
      DriverNotes(:driver_id="item.main_driver.id" :type="'highlightedNotes'" @notes="retriveLastNotes")
      .row.column.pl-2.pr-2.pt-2.pb-2
        .label last two notes
        .row.column.small-12( v-for ="(lastNote,key) in lastNotes") {{ lastNote }}
</template>

<script type="text/babel">
  import Accordion from '../../components/structure/foundation/Accordion'
  import DriverNotes from "./DriverNote.vue";
  import Driver from './Driver.vue'
  import Dropdown from 'components/structure/foundation/Dropdown'
  import CardN from 'components/structure/CardN'
  import Status from 'components/structure/ui/Status'
  import Wallet from 'components/backoffice/Wallet'
  import ClientActionButtons from 'components/structure/ui/actions/ClientActionButtons'
  import SimpleColumns2 from '../structure/simpleColums2.vue'
  import Thumbnail from '../structure/thumbnail'
  import {mapState} from 'vuex'
  import moment from 'moment'
  import AccountStatus from './AccountStatus'

  export default {
    name: 'BackofficeClient',
    data() {
      return {
        lastNotes: []
      }
    },
    props: {
      item: Object,
      type: {
        type: String,
        default: ''
      }
    },
    created() {
    },
    components: {
      AccountStatus,
      Thumbnail,
      SimpleColumns2,
      Driver,
      Accordion,
      CardN,
      Dropdown,
      Status,
      ClientActionButtons,
      Wallet,
      DriverNotes
    },
    methods: {
      retriveLastNotes(items) {
        var count = 0
        self = this
        console.log(items.items)
        items.items.forEach( function (item){
          if(count<2) {
            self.lastNotes.push(item.description)
            count++
          }
        })
      },
      update: function () {
        this.$emit('updated', this.item)
      },
      checkAddress: function (address) {
        return function sum(obj) {
          return Object.keys(obj)
            .reduce(function (sum, key) {
              return sum + parseFloat(obj[key])
            }, 0)
        }

        return !!sum(address)
      },
      daysWaiting(updated) {
        return moment(updated).fromNow(true)
      },
      formatDate(date) {
        return moment(date).format('DD/MM/YYYY')
      }
      // checkAddress: function (address) {
      //
      //   // return !!(Object.keys(address).reduce((a, b) => a + b, 0))
      // }
    },
    computed: {
      fiscalCode() {
        return this.item.fiscal_code ? this.item.fiscal_code.toUpperCase() : null
      },
      ...mapState({
        configuration: state => state.configuration,
      }),
      extra() {
        if (this.item.extra === null) {
          this.$set(this.item, 'extra', {})
          this.configuration.system.system_client_custom_fields.value.forEach((item) => {
            this.$set(this.item.extra, item.value, null)
          })
          return
        }
        return this.item.extra
      },
      accountStatus() {
        let accountStatus = this.item.account_status
        accountStatus.address = !!this.item.address.street
        return accountStatus
      }
    }
  }
</script>

<style lang="sass" rel="stylesheet/sass">
  .client-approval-card, .client.card.component-backoffice-client
    width: 100%

    img, p
      margin-bottom: 0

    .mb-0
      margin-bottom: 0

    .no-wrap
      white-space: nowrap

    .activeIcon
      color: #64db6f
</style>



// WEBPACK FOOTER //
// Client.vue?501fda2c